import { hashHistory } from 'react-router';

// All paths
const PATHS = {
  CHECKOUT: 'checkout',
};

const CHECKOUT_PATH = PATHS.CHECKOUT;

// Root
const CPM_CHECKOUT_PATH = `${CHECKOUT_PATH}`;

export const checkoutPath = () => CPM_CHECKOUT_PATH;

export const navigateToCheckout = (query = {}) => {
  hashHistory.push({
    pathname: checkoutPath(),
    query,
  });
};



// WEBPACK FOOTER //
// ./routes/checkout/navigation.js